"use strict";
/*

SHORTHANDS:
$kendo      - compilator.windowHandler.kendo
$radWindow  - compilator.windowHandler.radWindow

*/
// Defines compilator global namespace.
var compilator = compilator || {};

compilator.windowHandler = {
  openWindowWithFocus: function (url, windowName, openExistingWindowIfAny, scrollbars) {
    if (!windowName) {
      windowName = "";
    }
    //replace is needed because - in guids are not accepted
    const name = windowName.replace(/-/g, "");
    let features = "resizable=yes," +
      "directories=no," +
      "titlebar=no," +
      "toolbar=no," +
      "location=yes," +
      "status=no," +
      "menubar=no";

    if (scrollbars) {
      features = features + ",scrollbars=1";
    }

    let win;
    try {
      if (openExistingWindowIfAny === true) {
        // window.open with url = '' will either:
        //  a) Give a reference to a previously opened window with this name
        //  b) Open an empty window with this name, url will then be set to 'about:blank'
        win = window.open("", name, features, false);
        if (win.location.href === "about:blank") {
          win.document.body.innerHTML = "<div>" + $translations.Common.PleaseWaitWhilePageIsLoading + "</div>";
          win.location.href = url;
        }
        win.blur();
        win.focus();

        win.compilator.windowHandler.showCurrentWindow(url);
      } else {
        win = window.open(url, name, features, false);
        win.focus();
      }
    } catch (e) {
      // console.log(e);
    }

    return win;
  },
  showCurrentWindow: function (url) {
    window.focus();
    setTimeout(function () {
      $kendo.openKendoConfirmDialog($translations.Common.Confirm, $translations.Common.PageAlreadyOpen,
        function (ok) {
          if (ok) {
            window.location.href = url;
          }
        }, 400);
    }, 100);
  },
  openStorageCard: function (id) {
    const url = $string.format("/TyreHotel/StorageCard.aspx?id={0}", id);
    compilator.windowHandler.openWindowWithFocus(url, "storageCard_" + id, true);
  },
  openOwnerInfo: function (licenseplate, branchId, forceRefresh) {
    const url = $string.format("/Common/Vehicle/OwnerDetails?licenseplate={0}&branchId={1}&forceRefresh={2}", licenseplate, branchId, forceRefresh);
    compilator.windowHandler.openWindowWithFocus(url, "ownerInfo_" + licenseplate, true);
  },

  openVehicleDetails: function (licenseplate, branchId, forceRefresh) {
    const url = $string.format("/Common/Vehicle/Details?licenseplate={0}&branchId={1}&forceRefresh={2}", licenseplate, branchId, forceRefresh);
    compilator.windowHandler.openWindowWithFocus(url, "vehicleInfo_" + licenseplate, true);
  },
  //This opens a new order always in new window
  openNewOrderInNewWindow: function (branchId, isThirdPartyOrder) {
    var f_url = $url.OrderMVC.Order.OrderDetails.url1(null, branchId, isThirdPartyOrder, null);
    var f_args = [null, branchId, isThirdPartyOrder, null];
    var f_winId = f_args.join('_')
    var f_windowName = undefined;
    if (f_winId.replace(/_/g, '') != '') {
      f_windowName = 'OrderDetails_' + f_args.join('_') + Date.now(); //Date.now() is used to get unique windowname so it always opens a new window
    }
    compilator.windowHandler.openWindowWithFocus(f_url, f_windowName, false);
  },

  openNewContractInNewWindow: function (branchId) {
    const url = `/OrderMVC/Contract/Details?id=&copyFrom=&branchId=${branchId}`;
    const windowName = `ContractDetails_${Date.now()}`;
    compilator.windowHandler.openWindowWithFocus(url, windowName, false);
  },

  isOrderOpen: function (id, sellerBranchId, windowExistsCallback) {
    const name = "OrderDetails_" + id + "_" + sellerBranchId;

    const left = screen.width - 100;
    const top = screen.height - 100;

    const win = window.open("", name, "toolbar=no," +
      "location=no," +
      "status=no," +
      "menubar=no," +
      "scrollbars=no," +
      "resizable=no," +
      "width=100," +
      "height=100," +
      "top=" + top + "," +
      "left=" + left, false);
    if (win.location.href === "about:blank") {
      win.close();
      return false;
    }

    if (windowExistsCallback) {
      windowExistsCallback(win);
    }
    return true;
  }
};

compilator.windowHandler.kendo = {
  dialogResultOk: "Ok",
  dialogResultCancel: "Cancel",

  /** async wrapper for the openKendoConfirmDialog method */
  confirmDialog: async function (title, message, keepHtml = false) {
    return new Promise((resolve) => {
      $kendo.openKendoConfirmDialog(title, message, (e) => {
        resolve(e);
      }, null, keepHtml);
    });
  },

  attachWindow: function (name, settings) {
    const id = name + "Window";
    if (!$("#" + id).length) {
      $("body").prepend(`<div id="${id}"></div>`);
    }

    return $("#" + id).kendoWindow(settings).data("kendoWindow");
  },

  createAndOpenHtmlViewWindow: function (name, settings) {
    let tempSettings = Object.assign({}, settings);
    
    let windowSettings = {
      modal: true,
      visible: false,
      resizable: false,
      iframe: false,
      animation: false,
      close: function () {
        if (tempSettings.close) {
          tempSettings.close();
        }        
        //Bugfix: Overlay wasn't closed properly second time the dialog was opened when closing with cross.
        setTimeout(function () {
          $('body > .k-overlay').hide();
        }, 10);
      }
    };
    let ajaxSettings = {
      type: "POST",
      data: {},
    }

    $.extend(ajaxSettings, settings.view);
    delete settings.view;
    delete settings.close;    

    $.extend(windowSettings, settings);

    const id = name + "Window";
    if (!$("#" + id).length) {
      $("body").prepend(`<div id="${id}"></div>`);
    }
   
    let window = $("#" + id).kendoWindow(windowSettings).data("kendoWindow");
    window.refresh(ajaxSettings).center().open();
    return window;
  },

  openNewKendoWindow: function (content, userParams) {
    userParams = userParams || {};
    if (content.startsWith("#")) {
      $.extend(userParams, {
        windowName: content.substring(1),
        iframe: false,
        destroyOnClose: false
      })
      content = undefined;
    }

    if (userParams.title) {
      // Make sure title is decoded (so special characters will appear correctly)
      userParams.title = $("<div/>").html(userParams.title).text();
    }
    const params = {
      content: content,
      windowName: "kendo_wnd_" + ++this.lastNotificationDialogId,
      resizable: false,
      animation: false,
      title: "",
      modal: true,
      iframe: true,
      destroyOnClose: true,
      visible: false
    };

    // If userParams.iframe is set and it's set to true OR userParams.iframe is not set (default value, true, will be used)
    if ((userParams.iframe && userParams.iframe === true) || userParams.iframe === undefined) {
      $.extend(params, {
        width: 400,
        height: 200,
        minWidth: 400,
        minHeight: 200
      });
    }

    if (userParams.position) {
      params.width = window.innerWidth - (2 * userParams.position.left);
      params.height = window.innerHeight - (2 * userParams.position.top);

      if (userParams.position.maxAutomaticWidth && params.width > userParams.position.maxAutomaticWidth) {
        params.width = userParams.position.maxAutomaticWidth;
      }
      if (userParams.position.maxAutomaticHeight && params.height > userParams.position.maxAutomaticHeight) {
        params.height = userParams.position.maxAutomaticHeight;
      }
    }

    $.extend(params, userParams);
    const kendoMethods = {
      resize: function () {
        this._userManuallyChangedSize = true;
      },
      refresh: function () {
        try {
          if (params.onWindowRefresh) {
            params.onWindowRefresh(this);
          }

          const iframe = $(this.element).find("iframe");
          if (iframe.length !== 0) {
            const iframeContent = iframe.contents();
            const html = $("html", iframeContent);
            html.attr("data-kendo-window-name", params.windowName);

            if (iframe[0].contentWindow.kendoWindowOptions) {
              if (iframe[0].contentWindow.kendoWindowOptions.title) {
                // Make sure title is decoded (so special characters will appear correctly)
                iframe[0].contentWindow.kendoWindowOptions.title = $("<div/>").html(iframe[0].contentWindow.kendoWindowOptions.title).text();
              }
              this.setOptions(iframe[0].contentWindow.kendoWindowOptions);
            }

            if (!params.noFocusOnRefresh) {
              $("[type=submit]", html).focus();
            }           

            if (iframe[0].contentWindow.kendoWindowEvents && iframe[0].contentWindow.kendoWindowEvents.kendoWindowRefreshed) {
              // Make sure title is decoded (so special characters will appear correctly)
              iframe[0].contentWindow.dialogTitle = $("<div/>").html(iframe[0].contentWindow.dialogTitle).text();

              iframe[0].contentWindow.kendoWindowEvents.kendoWindowRefreshed(this);
            }

            if (this.title() === "") {
              const titleFromHead = $("head title", iframeContent).text();
              if (titleFromHead) {
                this.title(titleFromHead);
              }
            }
          } else {
            // No iframe
            $("[id]", this.element).each(function (i, v) {
              if ($("[id=" + v.id + "]").length !== 1) {
                throw "There are multiple elements with same id: " + v.id;
              }
            });

          }
        } catch (e) {
          console.error("Exception when refreshing window.", e);
        }
      },
      close: function (e) {
        const iframe = $(this.element).find("iframe");
        let args;
        try {
          args = this.element.data("kendo-close-args");
          if (iframe.length !== 0) {
            if (iframe[0].contentWindow.kendoWindowEvents && iframe[0].contentWindow.kendoWindowEvents.kendoWindowClosing) {
              if (!iframe[0].contentWindow.kendoWindowEvents.kendoWindowClosing(e, args)) {
                return;
              }
            }
          }
        } catch (e) {
          console.error("Exception when trying to close window.", e);
        }

        if (params.onWindowClose) {
          $.when(params.onWindowClose(args)).done(function () {
            //Fix for an IE bug. (IE 9 and IE 10 cannot enter text into input text boxes from time to time)
            //https://stackoverflow.com/questions/19150008/ie-9-and-ie-10-cannot-enter-text-into-input-text-boxes-from-time-to-time
            if (iframe) {
              iframe.empty().remove();
            }
          });
        }
        else {
          if (iframe) {
            iframe.empty().remove();
          }

        }
      },
      deactivate: function (e) {
        if (params.destroyOnClose) {
          e.sender.destroy();
        }
      }
    };

    $.extend(params, kendoMethods);

    if ($("#" + params.windowName).length === 0) {
      $("body").append("<div id='" + params.windowName + "'></div>");
    }

    //Replace single and double quotes with encoded values.
    if (params.content) {
      params.content = params.content.replace(/'/g, "%27");
    }
    const dialog = $("#" + params.windowName).kendoWindow(params);
    dialog.parents(".k-window").addClass("kendoWindow_Compilator");

    const kendoWindow = dialog.data("kendoWindow");
    const onWindowResize = function () {
      const startWidth = parseInt(kendoWindow.options.width);
      const startHeight = parseInt(kendoWindow.options.height);

      let width = startWidth;
      let height = startHeight;

      if (width > window.innerWidth) {
        width = window.innerWidth - 50;
      }
      if (height > window.innerHeight) {
        height = window.innerHeight - 40;
      }

      if (userParams.position && !kendoWindow._userManuallyChangedSize) {
        width = window.innerWidth - (2 * userParams.position.left);
        height = window.innerHeight - (2 * userParams.position.top);
        if (userParams.position.maxAutomaticWidth && width > userParams.position.maxAutomaticWidth) {
          width = userParams.position.maxAutomaticWidth;
        }
        if (userParams.position.maxAutomaticHeight && height > userParams.position.maxAutomaticHeight) {
          height = userParams.position.maxAutomaticHeight;
        }
      }

      if (width !== kendoWindow.options.width || height !== kendoWindow.options.height) {
        kendoWindow.setOptions({
          width: width,
          height: height
        });
      }

      kendoWindow.center();
    };

    window.addEventListener("resize", onWindowResize);

    kendoWindow.bind("deactivate", function () {
      window.removeEventListener("resize", onWindowResize);
    });

    return kendoWindow.center().open();
  },
  lastNotificationDialogId: 0,
  openKendoConfirmDialog: function (title, message, onWindowClose, maxWidth, keepHtml, useOkAndCancelButtons) {
    // Make sure message is decoded (so special characters will appear correctly)
    if (!keepHtml) {
      message = $("<div/>").html(message).text();
    }

    // Replaces 'Yes' and 'No' buttons with 'Ok' and 'Cancel' buttons if true
    if (useOkAndCancelButtons === undefined) {
      useOkAndCancelButtons = false;
    }

    //Add html tags instead of linebreaks
    message = message.replace(/\n/g, "<br />")
    if (maxWidth === undefined) {
      maxWidth = 500;
    }
    $kendo.lastNotificationDialogId += 1;
    const windowName = "notificationDialog" + $kendo.lastNotificationDialogId;

    $("body").append($("<div id='" + windowName + "'></div>").load($url.Layout.Dialog.ConfirmDialog.url() + "/?useOkAndCancelButtons=" + useOkAndCancelButtons, { cache: true }, function (responseText) {
      $("#" + windowName).html($("#" + windowName).html().replace(/{message}/g, message).replace(/{windowName}/g, windowName));

      $("#" + windowName + " input[type=submit]").get(0).focus();
      $("#" + windowName).data("kendoWindow").center();
    }));

    // Make sure title is decoded (so special characters will appear correctly)
    title = $("<div/>").html(title).text();
    const dialog = $("#" + windowName).kendoWindow({
      content: null,
      actions: ["Close"],
      modal: true,
      title: title,
      minWidth: 350,
      maxWidth: maxWidth,
      animation: false,
      visible: false,
      close: function () {
        if (onWindowClose != undefined) {
          const args = $(this.element).data("kendo-close-args");
          onWindowClose(args);
        }
        dialog.destroy();
      }
    }).data("kendoWindow").center().open();
    $("#" + windowName).parents(".k-window").addClass("kendoWindowNotification_Compilator");
    return dialog;
  },
  openKendoWindowNotification: function (title, message, btnOktext, error, modal, onWindowClose, dontStripHtml) {
    // Make sure message is decoded (so special characters will appear correctly)
    if (!dontStripHtml) {
      message = $("<div/>").html(message).text();
    }

    let icon = "info.png";
    if (error) {
      icon = "warning32.png";
    }

    $kendo.lastNotificationDialogId += 1;
    const windowName = "notificationDialog" + $kendo.lastNotificationDialogId;

    $('body').append('<div id="' + windowName + '">\
                        <div class="rnContentWrapper" id="radErrorNotification_C">\
                          <div class="notificationContainer">\
                            <div style="overflow: visible; margin-bottom: 10px;">\
                              <div class="icon" style="overflow:visible; float:left;">\
                                <img id="imgErrorIcon"  style="border-width: 0px; width:32px; height:32px; margin-right: 10px; "\
                                src="/Images/Icons/' + icon + '">\
                              </div>\
                              <div class="message" style="margin-top:5px; padding-bottom:15px; padding-right:10px; float:right; width:80%;">\
                                <span id="lblErrorMessage">' + message + '</span>\
                              </div>\
                              <div style="clear: both;"></div>\
                              <div class="controls" style="padding-right:10px;">\
                                <input class="k-button" name="btnErrorClose" onclick="$(\'#' + windowName + '\').data(\'kendoWindow\').close();\
                                  return false;" type="submit" value="' + btnOktext + '" style="float:right;">\
                              </div>\
                            </div>\
                          </div>\
                        </div>\
                      </div>');

    // Make sure title is decoded (so special characters will appear correctly)
    title = $("<div/>").html(title).text();

    const dialog = $("#" + windowName).kendoWindow({
      content: null,
      actions: ["Close"],
      modal: modal,
      title: title,
      minWidth: 300,
      maxWidth: 500,
      visible: false,
      close: function () {
        if (onWindowClose) {
          onWindowClose();
        }
        dialog.destroy();
      }
    }).data("kendoWindow").center().open();
    $("#" + windowName).parents(".k-window").addClass("kendoWindowNotification_Compilator");

    $("#" + windowName + " input[type=submit]").get(0).focus();
    setTimeout(function () { $("#" + windowName + " input[type=submit]").get(0).focus(); }, 500);
    return;
  },

  openKendoErrorDialog: function (errorDetails, onWindowClose, title) {
    errorDetails = errorDetails || {};
    if (errorDetails.responseJSON && errorDetails.responseJSON.Content) {
      errorDetails = errorDetails.responseJSON.Content;
    }
    else if (errorDetails.responseJSON) {
      errorDetails = errorDetails.responseJSON;
    }

    $kendo.lastNotificationDialogId += 1;
    const windowName = "errorDialog" + $kendo.lastNotificationDialogId;
    let errorId = "";
    if (errorDetails.CorrelationId) {
      errorId = '<div class="message"><span>' + $translations.Common.ErrorId.replace('{0}', errorDetails.CorrelationId) + '</span></div>';
    }

    let message = $translations.Common.GeneralErrorMessage;
    let exceptionDetails = '';
    if (typeof errorDetails === 'string') {
      message = errorDetails;
    }
    else if (errorDetails && errorDetails.Exception) {
      exceptionDetails = "<div class='message' style='margin: 15px; max-height: 300px; overflow: auto; width: 95%'>";
      if (errorDetails.Exception.Message) {
        exceptionDetails += "<div>" + errorDetails.Exception.Message + "</div>";
      }
      if (errorDetails.Exception.StackTrace) {
        exceptionDetails += "<div>" + errorDetails.Exception.StackTrace.replace(/\</g, "&lt;").replace(/\>/g, "&gt;").replace(/(?:\r\n|\r|\n)/g, '<br />') + "</div>";
      }
      exceptionDetails += "</div>";
    }

    // Make sure message is decoded (so special characters will appear correctly)
    message = $("<div/>").html(message).text();
    // Convert \n to <br />:
    message = message.replace(/\n/g, '<br />');
    $('body').append('<div id="' + windowName + '">\
                        <div class="rnContentWrapper">\
                          <div class="notificationContainer">\
                            <div class="icon">\
                              <img  style="border-width: 0px; margin-right: 15px; float:left;"\
                              src="/Images/Icons/warning32.png">\
                            </div>\
                            <div style="padding-bottom:15px; padding-right:10px;">\
                              <div class="message" style="margin-top:5px; margin-left: 50px;">\
                                <span>' + message + '</span>\
                              </div>'
      + errorId.concat(exceptionDetails) +
      '</div>\
                            <div style="clear: both;></div>\
                            <div class="controls" style="padding-right:10px;">\
                              <input class="k-button" onclick="$(\'#' + windowName + '\').data(\'kendoWindow\').close();\
                                return false;" type="submit" value="' + $translations.Common.OK + '" style="float:right;">\
                            </div>\
                          </div>\
                      </div>\
                    </div>');

    // Make sure title is decoded (so special characters will appear correctly)
    title = title || $translations.Common.ErrorNotificationTitle;
    title = $("<div/>").html(title).text();

    const dialog = $('#' + windowName).kendoWindow({
      content: null,
      actions: ["Close"],
      modal: true,
      title: title,
      minWidth: 400,
      maxWidth: exceptionDetails ? ($(document).width() - 100) : 500,
      visible: false,
      close: function () {
        if (onWindowClose != undefined) {
          onWindowClose();
        }
        dialog.destroy();
      }
    }).data('kendoWindow').center().open();
    $('#' + windowName).parents('.k-window').addClass('kendoWindowNotification_Compilator');

    $('#' + windowName + ' input[type=submit]').get(0).focus();
    setTimeout(function () { $('#' + windowName + ' input[type=submit]').get(0).focus(); }, 500);
    return;
  },
  _getCurrentKendoWindow: function (element) {
    const returnValue = {
      containingWindow: undefined,
      kendoWindow: undefined
    };

    if (element) {
      const kendoWindowDiv = $(element).closest('[data-role=window]');
      if (kendoWindowDiv.length !== 0) {
        returnValue.kendoWindow = kendoWindowDiv.data('kendoWindow');
        returnValue.containingWindow = window;
        return returnValue;
      }
    }

    let windowName = $('html').data('kendo-window-name');
    if (windowName === undefined || windowName === '') {
      windowName = $('html').attr('data-kendo-window-name');
    }

    let containingWindow = window;
    while (containingWindow !== containingWindow.top) {
      if (containingWindow.$('#' + windowName).data('kendoWindow')) {
        returnValue.kendoWindow = containingWindow.$('#' + windowName).data('kendoWindow');
        returnValue.containingWindow = containingWindow;
        return returnValue;
      }
      containingWindow = containingWindow.parent;
    };

    if (containingWindow === window) {
      // Not iframe
      if (element === undefined) {
        // Return first available kendo window (possible multiple dialogs on page)
        returnValue.kendoWindow = $('[data-role=window]').data('kendoWindow');
      }
    }
    else {
      returnValue.kendoWindow = containingWindow.$('#' + windowName).data('kendoWindow');
    }

    returnValue.containingWindow = containingWindow;

    return returnValue;
  },
  getCurrentKendoWindow: function (element) {
    return this._getCurrentKendoWindow(element).kendoWindow;
  },

  closeKendoWindowById: function (args, id) {
    let kendoWindow = null;
    if (parent === top) {
      window.parent.$('#' + id).data('kendo-close-args', args);
      kendoWindow = window.parent.$('#' + id).data('kendoWindow');
    }
    else {
      $('#' + id).data('kendo-close-args', args);
      kendoWindow = $('#' + id).data('kendoWindow');
    }
    kendoWindow.close();
  },
  closeCurrentKendoWindow: function (args, element) {
    const ret = this._getCurrentKendoWindow(element);
    ret.containingWindow.$(ret.kendoWindow.element).data('kendo-close-args', args);

    ret.kendoWindow.close();
  }
}

compilator.windowHandler.kendo.windows = {
  openContactDetailsWindow: function (params) {
    const options = {
      title: '',
      saveOnPost: false,
      readonly: true,
      allowCreate: false,
      allowEdit: false,
      contactId: '',
      customerId: '',
      onWindowClose: undefined,
      functionToLoadContact: '',
      modal: true,
      windowName: 'ContactDetails',
      width: 650,
      height: 600
    };
    $.extend(options, params);

    $url.Business.Contact.ContactDetails.kendoWindow(options.contactId,
      options.customerId,
      options.allowCreate,
      options.allowEdit,
      options.saveOnPost,
      options.readonly,
      options.functionToLoadContact,
      options.allowDelete,
      options.isPurchaser,
      options);

    return false;
  },
  openCustomerSearchWindow: function (callModule, callback, params) {
    const options = {
      onWindowClose: function (args) {
        if (callback) {
          callback(args);
        }
      },
      modal: true,
      windowName: 'SearchCustomers',
      resizable: true,
      position: {
        left: 100,
        top: 75,
        maxAutomaticWidth: 1500,
        maxAutomaticHeight: 800
      },
      minWidth: 1200
    };
    $.extend(options, params);

    const windowUrl = '/Business/Windows/SearchCustomer.aspx?CallModule=' + callModule;
    $kendo.openNewKendoWindow(windowUrl, options);
    return false;
  },
  openStockBalance: function (params) {
    const options = {
      articleId: '',
      title: '',
      width: 700,
      height: 450
    };
    $.extend(options, params);
    const windowUrl = '/Windows/ViewStockBalance.aspx?articleId=' + options.articleId;
    $kendo.openNewKendoWindow(windowUrl, options);
  }
}

compilator.windowHandler.radWindow = {
  dialogResultOK: "Ok",
  dialogResultCancel: "Cancel",
  radWindowId: 0,

  getCurrentRadWindow: function () {
    let radWindow = null;

    if (window.radWindow) {
      radWindow = window.radWindow;
    }
    else if (window.frameElement.radWindow) {
      radWindow = window.frameElement.radWindow;
    }

    return radWindow;
  },

  closeCurrentRadWindow: function () {
    this.getCurrentRadWindow().close();
  },

  // Creates and opens a JS RadWindow, and sets the properties supplied in the parameter object.
  // Mandatory properties: windowId, url, witdh, height, title.
  // Optional (default will be used if not supplied): modal, reloadOnShow, destroyOnclose, closeEnabled, keepInScreenBounds, visibleStatusBar, onWindowClose, showContentDuringLoad.
  // Add more properties if needed.
  openRadWindow: function (properties) {
    if (typeof radopen === 'undefined') {
      return null;
    }

    // Extending non supplied properties with default properties.
    const defaultProperties = {
      modal: true,
      reloadOnShow: true,
      destroyOnClose: true,
      closeEnabled: true,
      keepInScreenBounds: true,
      visibleStatusbar: false,
      showContentDuringLoad: false
    };
    properties = $.extend(defaultProperties, properties);

    const radWindow = radopen(properties.url, properties.windowId);

    // Set properties
    radWindow.set_title(properties.title);
    radWindow.set_width(properties.width);
    radWindow.set_height(properties.height);
    radWindow.set_modal(properties.modal);
    radWindow.set_reloadOnShow(properties.reloadOnShow);
    radWindow.set_destroyOnClose(properties.destroyOnClose);
    radWindow.set_keepInScreenBounds(properties.keepInScreenBounds);
    radWindow.set_visibleStatusbar(properties.visibleStatusbar);
    radWindow.set_showContentDuringLoad(properties.showContentDuringLoad);

    if (properties.closeEnabled) {
      radWindow.set_behaviors(Telerik.Web.UI.WindowBehaviors.Move + Telerik.Web.UI.WindowBehaviors.Close);
    } else {
      radWindow.set_behaviors(Telerik.Web.UI.WindowBehaviors.Move);
    }

    // Due to a bug in telerik, destroyonclose cannot be used in combination with onWindowClose. (!= instead of !== used for checking both null and undefined)
    if (properties.onWindowClose != undefined) {
      radWindow.remove_close(properties.onWindowClose);
      radWindow.add_close(properties.onWindowClose);
      radWindow.set_destroyOnClose(false);
    }

    radWindow.center();
    $(".rwCloseButton").prop("title", GetTranslatedCloseText());
    $(".rwCloseButton").css("cursor", "pointer");

    return radWindow;
  },

  openRadWindowConfirmDialog: function (confirmText, title, onWindowClose) {
    return this.openRadWindow({
      url: '/Common/Windows/Confirm.aspx?DialogType=1&ConfirmText=' + confirmText,
      windowId: '_rwConfirmDialog',
      width: 320,
      height: 150,
      closeEnabled: false,
      title: title,
      onWindowClose: onWindowClose
    });
  },

  //Opens a rad window with a new windowId each time it's called.
  openRadWindowQuestionDialog: function (confirmText, title, confirmText2, defaultButton, onWindowClose) {
    return this.openRadWindow({
      url: '/Common/Windows/Confirm.aspx?DialogType=2&ConfirmText=' + confirmText + '&ConfirmText2=' + confirmText2 + '&DefaultButton=' + defaultButton,
      windowId: '_rwQuestionDialog' + this.radWindowId++,
      width: 320,
      height: 150,
      closeEnabled: false,
      title: title,
      onWindowClose: onWindowClose
    });
  },

  // Old function. Should be removed when(if?) all calls are updated to use openRadWindow() directly.
  openJSRadWindowDestroyOnClose: function (url, windowId, title, width, height, modal, onWindowClose) {
    return this.openRadWindow({
      url: url,
      windowId: windowId,
      title: title,
      width: width,
      height: height,
      modal: modal,
      onWindowClose: onWindowClose
    })
  }
}

// Contains functions for client-side displaying of notifications 
compilator.windowHandler.notifications = function (errorTitle, informationTitle, okButtonText) {
  this.showNotification = function (text, callback) {
    $kendo.openKendoWindowNotification(informationTitle, text, okButtonText, false, false, callback);
  };

  this.showErrorNotification = function (text, callback) {
    $kendo.openKendoWindowNotification(errorTitle, text, okButtonText, true, false, callback);
  };
};

compilator.windowHandler.printing = {
  _printingWindowHeight: 135,
  _printingWindowWidth: 280,
  _printingWindowCenterHeight: 250,
  _printingWindowCenterWidth: 500,

  openPrintingWindow: function (url) {
    const screenTop = screen.availHeight - this._printingWindowHeight;
    const screenLeft = screen.availWidth - this._printingWindowWidth;
    const windowProperties = 'height=' + this._printingWindowHeight +
      ',width=' + this._printingWindowWidth +
      ',top=' + screenTop +
      ',left=' + screenLeft +
      ',resizable=yes' +
      ',directories=no' +
      ',titlebar=no' +
      ',toolbar=no' +
      ',location=no' +
      ',status=no' +
      ',menubar=no';

    const win = window.open(url, '_blank', windowProperties);

    if (win === null || typeof (win) === 'undefined') {
      if (window.parent !== undefined) {
        window.parent.displayPopupBlockerInfo();
      }
    }

    return false;
  },

  movePrintingWindowToCenter: function () {
    const posLeft = (screen.width / 2) - (this._printingWindowCenterWidth / 2);
    const posTop = (screen.availHeight / 2) - (this._printingWindowCenterHeight / 2);

    window.moveTo(posLeft, posTop);
    window.resizeTo(this._printingWindowCenterWidth, this._printingWindowCenterHeight);

    window.focus();
  },

  movePrintingWindowToBottom: function () {
    const screenTop = screen.availHeight - this._printingWindowHeight;
    const screenLeft = screen.availWidth - this._printingWindowWidth;

    window.moveTo(screenLeft, screenTop);
    window.resizeTo(this._printingWindowWidth, this._printingWindowHeight);
  },
};

// Common message listener for receiving messages from child windows (in iframes) that need to perform operations in the main window.
$(document).ready(function () {
  if (window.addEventListener) // W3C DOM
    window.addEventListener("message", windowOperationsEventListener, false);
  else if (window.attachEvent) // IE DOM
    window.attachEvent("onmessage", windowOperationsEventListener, false);
});

function windowOperationsEventListener(e) {
  // Check the origin to make sure it comes from a trusted source.
  if (e.origin !== window.location.origin) {
    return;
  }

  if (e.data.action === "CloseWindows" || e.data.closeAllOtherWindows === true) {
    $(".k-window-content").each(function () {
      $(this).data("kendoWindow").close();
    });
  }
  if (e.data.action === "OpenKendoWindow") {
    const winWidth = e.data.width || 600;
    const winHeight = e.data.height || 450;
    const winTitle = e.data.title || "";

    $kendo.openNewKendoWindow(e.data.windowUrl, { title: winTitle, width: winWidth, height: winHeight, onWindowClose: e.data.onWindowClose });
  }
  else if (e.data.action === "DisplayMessage") {
    $kendo.openKendoWindowNotification(e.data.title || $translations.Common.Information,
      e.data.message,
      e.data.buttonText || $translations.Common.OK,
      false,
      true);
  }
}

// Below is used by old code in tyrehotel. When code is updated to create radwindows with windowHandler instead of in markup, these functions can be deleted. 
function openWin(windowId) {
  const oWnd = $find(windowId);
  oWnd.show();
  $(".rwCloseButton").prop("title", GetTranslatedCloseText());
  $(".rwCloseButton").css("cursor", "pointer");
}

function openWindow(url, id, positionBottom) {
  const oWnd = $find(id);
  oWnd.setUrl(url);

  oWnd.show();

  if (positionBottom) {
    const bounds = $telerik.getClientBounds();
    oWnd.moveTo(bounds.width - oWnd.get_width(), bounds.height - oWnd.get_height());
  }

  $(".rwCloseButton").prop("title", GetTranslatedCloseText());
  $(".rwCloseButton").css("cursor", "pointer");
}

var $kendo = compilator.windowHandler.kendo;
var $radWindow = compilator.windowHandler.radWindow;